import { trackEvent as t } from '../track';

export const settings = {
  viewApps: () => t('[Settings] View apps'),
  viewOrgMembers: () => t('[Settings] View organization members'),
};
